import React from 'react';
import { MessageCircle } from 'lucide-react';

interface WhatsAppButtonProps {
  phoneNumber: string;
}

export const WhatsAppButton: React.FC<WhatsAppButtonProps> = ({ phoneNumber }) => {
  const handleClick = () => {
    // Format phone number by removing spaces and special characters
    const formattedNumber = phoneNumber.replace(/\s+/g, '').replace(/[^0-9]/g, '');
    
    // Try app protocol first, fallback to web link
    const appUrl = `whatsapp://send?phone=${formattedNumber}`;
    const webUrl = `https://wa.me/${formattedNumber}`;
    
    // Create a temporary link and click it
    const link = document.createElement('a');
    link.href = appUrl;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    
    // Fallback to web if app doesn't open
    const timeout = setTimeout(() => {
      window.location.href = webUrl;
    }, 1000);
    
    link.onclick = () => clearTimeout(timeout);
    link.click();
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-primary hover:bg-primary/90 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 active:scale-95"
      aria-label="Contact us on WhatsApp"
    >
      <MessageCircle className="w-7 h-7 text-white" />
      
      {/* CSS-only pulse effect */}
      <div className="absolute inset-0 rounded-full bg-primary/50 animate-ping" style={{ animationDuration: '2s' }} />
    </button>
  );
};
